import React from "react";
import Header from "./../sharedScreens/Header";
import SideMenu from "./../sharedScreens/menuItems/SideMenu";
import { FormikValues, useFormik } from "formik";
import { CreateUserSchema } from "./../validations/Schema";
import { MuiInput } from "./../components/basicComponent/MuiInput";
import { MuiDropDown } from "./../components/basicComponent/MuiDropDown";
import { useNavigate, useLocation } from "react-router-dom";
import MuiButton from "./../components/basicComponent/MuiButton";
import { UserModel } from "./../model/controlPanelModels/CreateUserModel";
import MuiSearchSelect from "./../components/basicComponent/MuiSearchSelect";

const Ticket = () => {
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">Ticket Points </h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    <div className="row mt-4">
                      <div className="col-md-4">
                        <MuiSearchSelect
                          placeholder={"Category"}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiInput label="Position" placeholder="Position" />
                      </div>
                      <div className="col-md-4">
                        <MuiSearchSelect
                          placeholder={"Type"}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label="Title"
                          placeholder="Enter Title"
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label="Content"
                        />
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        marginTop: "8px",
                      }}
                    >
                      <div className="user-button w-full">
                        <MuiButton
                          className="clear-btn "
                          label="Clear"
                          type="submit"
                        />
                        <MuiButton
                          label={"SUBMIT"}
                          className="main-btn get-btn"
                          variant="contained"
                          size="large"
                          type="submit"
                        />
                      </div>
                      {/* <MuiButton
                      label={editingUser ? "Update User" : "Create User"}
                      className="main-btn"
                      variant="contained"
                      size="large"
                      onClick={() => formik.handleSubmit()}
                    /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Ticket;
